const defaultConfig = require('./src/base/config/next-i18next.config');

/** @type {import('next-i18next').UserConfig} */
module.exports = {
	...defaultConfig,
	i18n: {
		...defaultConfig.i18n,
		ns: [
			...defaultConfig.i18n.ns || [],
			// Custom declared namespaces from /public/locale
			'common',
			'calculator',
			'reviews',
			'faq',
			'landing-pl',
			'blog',
			'meta',
			'auth'
		]
	}
};